import {Component, EventEmitter, Input, OnInit, Output, inject} from '@angular/core';
import {MfaService} from '../../_services/data/mfa.service';
import {DeviceDetails} from '../../_data/mfa/mfa-user-details';
import {switchMap} from 'rxjs/operators';
import {of} from 'rxjs';
import {ConfirmModalService} from '../../_services/gui/confirm-modal.service';
import {AuthenticationService} from '../../_services/authentication.service';
import {exists} from '../../_utils/operators';
import {MfaPairingResponse} from '../../_data/mfa/mfa-pairing';
import {NotificationService} from '../../_services/gui/notification.service';
import {PingErrorId} from '../../_constants/types';
import {FaIconComponent} from '@fortawesome/angular-fontawesome';
import {TranslateModule} from '@ngx-translate/core';

@Component({
    selector: 'app-mfa-enabled-device',
    templateUrl: './enabled-device.component.html',
    styleUrls: ['./enabled-device.component.scss'],
    imports: [FaIconComponent, TranslateModule]
})
export class EnabledDeviceComponent implements OnInit {

  @Input() userName: string;
  @Input() device: DeviceDetails;
  @Input() numMfaDevice: number;

  /**
   * Allows the user to change which device is primary using buttons
   */
  @Input() allowChangingPrimary = true;

  /**
   * Allows the user to remove devices using buttons
   */
  @Input() allowRemovingDevice = true;

  @Output() removed: EventEmitter<void> = new EventEmitter<void>();
  @Output() updatedPrimary: EventEmitter<void> = new EventEmitter<void>();

  mfaService = inject(MfaService);
  private authenticationService = inject(AuthenticationService);
  private modalService = inject(ConfirmModalService);
  private notificationService = inject(NotificationService);

  ngOnInit(): void {
  }

  //TODO: reduce code duplication between this and the confirmPrimary method below
  confirmRemove(ariaLabelledBy: string, container: HTMLElement) {
    this.modalService.open(
      {i18nKey: 'content.remove'},
      {i18nKey: this.numMfaDevice > 1 ? 'content.confirm-remove-device' : 'content.confirm-remove-last-device' , data: {device: this.device.displayID}},
      ariaLabelledBy,
      container
    ).result$.pipe(
      switchMap(accepted => {
        if(accepted) {
          console.debug(`OK clicked.`);
          return this.mfaService.unpairDevice({userMFADetails: {userName: this.userName}, deviceId: this.device.deviceId});
        } else {
          return of(null);
        }
      })
    ).pipe(exists()).subscribe((mfaResponse: MfaPairingResponse) => {
      console.debug(`Removal response: ${JSON.stringify(mfaResponse)}`);
      if(mfaResponse.errorId === PingErrorId.ok) {
        this.notificationService.displayI18n('content.mfa-device-removed');
        this.removed.emit();
      }
    });
  }

  confirmPrimary(ariaLabelledBy: string, container: HTMLElement) {
    this.modalService.open(
      {i18nKey: 'content.mfa-make-device-primary'},
      {i18nKey: 'content.confirm-mfa-device-primary', data: {device: this.device.displayID}},
      ariaLabelledBy,
      container
    ).result$.pipe(
      switchMap(accepted => {
        if(accepted) {
          console.debug(`OK clicked.`);
          return this.mfaService.updatePrimaryDevice({userMFADetails: {userName: this.userName}, deviceId: this.device.deviceId});
        } else {
          return of(null);
        }
      })
    ).pipe(exists()).subscribe((mfaResponse: MfaPairingResponse) => {
      console.debug(`Update primary response: ${JSON.stringify(mfaResponse)}`);
      if(mfaResponse.errorId === PingErrorId.ok) {
        this.notificationService.displayI18n('content.device-updated');
        this.updatedPrimary.emit();
      }
    });
  }
}
